import React from 'react';
import { TextField, Box, Typography, Tooltip, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { useThemeContext } from '../../hook/useThemeManager';

interface InfoTextFieldProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    infoText?: string;
    placeholder?: string;
    multiline?: boolean;
    rows?: number;
    fullWidth?: boolean;
    sx?: any;
    InputProps?: any;
    InputLabelProps?: any;
}

export const InfoTextField: React.FC<InfoTextFieldProps> = ({
    label,
    value,
    onChange,
    infoText,
    placeholder,
    multiline,
    rows,
    fullWidth = true,
    sx,
    InputProps,
    InputLabelProps,
}) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box sx={{ position: 'relative' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography
                    sx={{
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        color: theme[themeStyle].light_gray_text,
                    }}>
                    {label}
                </Typography>
                {infoText && (
                    <Tooltip title={infoText} arrow placement="top">
                        <IconButton
                            size="small"
                            sx={{
                                ml: 1,
                                color: theme[themeStyle].light_gray_text,
                                '&:hover': {
                                    color: theme[themeStyle].primary_orange,
                                },
                            }}>
                            <InfoOutlined fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            <TextField
                fullWidth={fullWidth}
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                multiline={multiline}
                rows={rows}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        color: theme[themeStyle].tag_white,
                        backgroundColor: theme[themeStyle].gray_text,
                        '& fieldset': {
                            borderColor: theme[themeStyle].grey,
                        },
                        '&:hover fieldset': {
                            borderColor: theme[themeStyle].tag_white,
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: theme[themeStyle].primary_orange,
                        },
                    },
                    ...sx,
                }}
                InputProps={InputProps}
                InputLabelProps={InputLabelProps}
            />
        </Box>
    );
};
